import { FocusEvent, KeyboardEvent, RefObject } from 'react';

/**
 * Keyboard dismissal for a menu that slides over the page (the mobile menus). Spread the returned handlers on the
 * element that contains both the menu and its toggle button:
 * - focus moving to an element outside it closes the menu, so keyboard focus never ends up behind the overlay
 *   (WCAG 2.4.11); focus moving within it, back to the toggle included, keeps it open. Focus leaving without a new
 *   target (the window loses focus, a click on empty space) is ignored; clicking the overlay closes the menu itself;
 * - Escape closes the menu and returns focus to the toggle.
 *
 * @param isOpen only true while the menu is open *and* behaves as an overlay, so not for the always-visible desktop sidebar
 */
export const useDismissableMenu = (isOpen: boolean, close: () => void, toggleRef: RefObject<HTMLElement | null>) => ({
    onBlur: (event: FocusEvent<HTMLElement>) => {
        const next = event.relatedTarget;
        if (isOpen && next instanceof Node && !event.currentTarget.contains(next)) {
            close();
        }
    },
    onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
        if (isOpen && event.key === 'Escape') {
            close();
            toggleRef.current?.focus();
        }
    }
});
